
import DraggableScrollableList from '../components/draggableList'
import Heading from '../components/heading'
import EducatorCard from '../components/educatorCard'
import { Link } from 'react-router-dom'
import {  useRef, useState } from 'react'
// import axios from 'axios'
// import { apis } from '../api/apiUrl'
// import { showImage } from '../api/functions'
import { GraduatedCardSkelton } from '../components/skeltons'
import { useSelector } from 'react-redux'
import { retrunAssets } from '../utils/getAssets'
// import { useInView } from 'framer-motion'
// import ed1 from "../assets/ed1.svg"

const OurEducators = () => {
   
    const edu1 = useRef(null)
    // const isInViewEdu1 = useInView(edu1, { once: true });
    const state = useSelector(state => state.homepage)
    const data = state.data?.properties?.educators?.items.map(d => {
        return {
            img: retrunAssets(d?.content?.properties?.image[0].url),
            name: d?.content?.properties?.educatorName,
            designation: d?.content?.properties?.position,
            college: d?.content?.properties?.department
        }
    }
    )
    const [loading, ] = useState(false)
    // useEffect(() => {
    //     async function fetchData() {
    //         const response = await axios.get(apis.baseUrl + apis.getEducator);
    //         setData(response?.data.educators?.map(d => {
    //             return {
    //                 img: `${showImage(d.Image)}`,
    //                 designation: d.Quote,
    //                 college: d.Description,
    //                 name: d.Name
    //             }
    //         }));
    //         setLoading(false)
    //     }
    //     if(isInViewEdu1){
    //         fetchData();
        
    //     }
    // }, [isInViewEdu1]);
    return (
        <div ref={edu1} className="relative bg-[#f3f3f3]  flex items-start justify-center p-4">
            <div className="md:max-w-5xl min-h-[30rem] 2xl:max-w-full w-full h-full flex flex-col items-center justify-center  p-4 gap-3">
                <Heading name="Our Leaders" />
                <h1 className="text-4xl font-bold text-center">Our Dedicated Leaders</h1>
                <p className="md:text-xs 2xl:text-sm text-[#7f7f80] md:max-w-[45%] text-center w-full">At UNITEN we inspire minds into great leaders of the world.</p>
                <Link to={"/our-people"} className='p-2 px-3  border w-fit rounded-sm font-bold my-2 text-xs 2xl:text-sm text-[#0039cb] border-[#0039cb] flex items-center gap-1'>View All</Link>
               
                    <DraggableScrollableList >
                        {
                            loading ?
                            <>
                                {[1, 2, 3, 4].map(item =>
                                    <GraduatedCardSkelton key={item}/>
                                )}
                            </>
                            :
                            data?.map((graduate, index) => (
                                <EducatorCard key={index} {...graduate} />
                            ))
                        }
                    </DraggableScrollableList>
                
            </div>
        </div>
    )
}

export default OurEducators